import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import { useFlash } from 'contexts/flash';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { updateLocationName } from 'services/locations';
import { Location } from 'types/loctions';
import { renderTitle } from 'utils/renderTitleLocation';

type Props = {
  open: boolean;
  location: Location | null;
  onClose: () => void;
  onSuccess: () => void;
};

export const ModalEditLocationName = ({ open, location, onClose, onSuccess }: Props) => {
  const [name, setName] = useState('');
  const { setFlash } = useFlash();

  useEffect(() => {
    if (open && location) {
      setName(location.name);
    }
  }, [open, location]);

  const { asyncCallback: handleSave, isLoading } = useAsyncCallback(async () => {
    if (!location?.id) return;
    const trimmed = name.trim();
    if (!trimmed) {
      setFlash({ type: 'error', message: 'Name is required' });
      return;
    }
    if (trimmed === location.name) {
      onClose();
      return;
    }
    await updateLocationName(location.id, trimmed);
    setFlash({ type: 'success', message: 'Location name updated' });
    onSuccess();
    onClose();
  }, [location, name, onClose, onSuccess, setFlash]);

  if (!location) return null;

  return (
    <DialogConfirm
      isOpen={open}
      onClose={onClose}
      isIconClose
      textTitle="Rename location"
      textButton={isLoading ? '…' : 'Save'}
      textCancel="Cancel"
      onSubmit={() => void handleSave()}
      maxWidth={480}>
      <TextField
        fullWidth
        autoFocus
        label="Location name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        margin="normal"
        size="small"
        helperText={`${renderTitle(Number(location.level)).title}`}
      />
    </DialogConfirm>
  );
};
